import history from 'providers/history';
import React from 'react';
import FontAwesome from 'react-fontawesome';

import BreadcrumbTrail from 'components/global/application/BreadcrumbTrail';
import Expandable from 'components/global/application/Expandable';
import Button from 'components/global/form/Button';
import CartItemRow from 'containers/pages/accessories/cart/CartItemRow';

import Shopify from 'providers/shopify';
import CartItem from 'types/shopify/CartItem';

import './CartPage.sass';

export interface StateProps {
    isLoading: boolean;
    cart: CartItem[];
    baseUrl: string;
    totalPrice: number;
    isMobile: boolean;
}

interface State {
    emptyCartMessage: boolean;
}

class CartPage extends React.Component<StateProps, State> {
    constructor(props: StateProps) {
        super(props);

        this.state = { emptyCartMessage: false };
    }

    public componentWillMount() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    public componentDidUpdate() {
        (window as any).affirm.ui.refresh();
    }

    public render() {
        const { baseUrl, cart, isLoading, isMobile, totalPrice } = this.props;

        const affirmAttributes = {
            className: 'affirm-as-low-as',
            'data-amount': `${totalPrice.toFixed(0)}00`,
            'data-page-type': 'cart'
        };

        const affirmAction =  (<p {...affirmAttributes} />);

        return isLoading
        ? (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />) // SPINNER
        : (
            <div className="row cart-page-container">
                    <div className="col-10 offset-1">
                        <div className="row cart-breadcrumb">
                            <div className="col-12">
                                <BreadcrumbTrail pathNodes={[{ label:'Accessories', route:'/accessories' }, { label: 'Cart', route: '/accessories/cart' }]} />
                                <div className="cart-page-title">YOUR CART</div>
                            </div>
                        </div>
                        <div className="row">
                            <div className={`${!isMobile ? 'offset-1 ' : ''}col-md-6`}>
                                <div className="cart-item-rows">
                                {cart.map((item: CartItem, index: number) => {
                                    return <CartItemRow key={item.addedTime.valueOf()} item={item} />;
                                })}
                                </div>
                            </div>
                            <div className="col-md-3 text-center">
                                <div className="cart-details">
                                    <div className="total-price">${totalPrice.toFixed(2)}</div>
                                    <div className="cart-disclaimer">(does not include taxes/shipping)</div>
                                    <div className="total-label">Total:</div>
                                </div>
                                <Expandable direction="vertical" maxHeight="40px" expanded={this.state.emptyCartMessage} >
                                    <div className="empty-cart-message">Cannot checkout with an empty cart.</div>
                                </Expandable>
                                { cart.length > 0 ? (
                                        <div>
                                            {affirmAction}
                                            <a href={Shopify.generateCheckoutUrl(baseUrl, cart)}>
                                                <Button className="btn-checkout" >Proceed To Checkout</Button>
                                            </a>
                                        </div>)
                                : (
                                    <Button className="btn-checkout-disabled" onClick={() => this.setState({ emptyCartMessage: true })} >Proceed To Checkout</Button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}

export default CartPage;



// WEBPACK FOOTER //
// ./src/components/pages/accessories/cart/CartPage.tsx